// extracted by mini-css-extract-plugin
export default {"active":"Ata_active__glLek","center":"Ata_center__tCawi","noBorder":"Ata_noBorder__d7M79","right":"Ata_right__PLmIl","container":"Ata_container__Tkucf","item":"Ata_item__bwbgJ"};